<div class="content-container">
  <app-info-box></app-info-box>
  <app-result-manager></app-result-manager>
</div>
